"use strict";

export { default } from './BottomSheetView';
//# sourceMappingURL=index.js.map